export const normalizePackageItem = (item) => {
  const quantity = Number(item.quantity);
  if (typeof item.product !== "string" || !item.product.trim() || !Number.isFinite(quantity) || quantity <= 0) {
    throw new Error("Each package item needs a product and a positive quantity.");
  }
  return {
    product: item.product,
    product_name: item.product_name || item.product,
    quantity,
    unit: typeof item.unit === "string" && item.unit.trim() ? item.unit.trim() : "unit",
  };
};

export const combinePackageItems = (items) => {
  const products = new Map();
  items.forEach((raw) => {
    const item = normalizePackageItem(raw);
    const previous = products.get(item.product);
    if (previous) {
      if (previous.unit !== item.unit && previous.unit !== "unit" && item.unit !== "unit") {
        throw new Error("Cannot merge quantities with different units.");
      }
      item.quantity += previous.quantity;
      if (!Number.isFinite(item.quantity)) throw new Error("Merged quantity is too large.");
      if (item.unit === "unit") item.unit = previous.unit;
    }
    products.set(item.product, item);
  });
  return Array.from(products.values());
};
